export default __webpack_public_path__ + "static/media/planet2.efeacec1.png";